angular.module('bizmetryApp').controller('EditOrganizationDialogController', function (
    $scope,
    $mdDialog,
    $http,
    $timeout,
    $q,
    accountId,
    dialogService,
    CONFIG,
    ReferenceDataService,
    UserProfileService,
    ConfigurationService,
    geoLocationService,
    $mdToast
) {
    console.log('🏢 EditOrganizationDialogController initialized | accountId:', accountId);

    $scope.accountId = accountId;
    $scope.loading   = true;   // spinner visible desde el inicio
    $scope.locating  = false;  // spinner del botón Locate myself
    $scope.saving    = false;  // spinner del botón Save (el contenido sigue visible)

    $scope.activeTab = 0;      // 0 = General, 1 = Preferences

    // Ingestion Hub Retention Time Window: slider bounds and default from the central config
    // (shared-services' central-config ConfigMap); account-ms enforces the same range.
    var retentionConfig = ConfigurationService.getFromCache(
        'frontend.organization_preferences.ingestion_hub_retention_hours') || {};
    function positiveInt(value, fallback) {
        var n = parseInt(value, 10);
        return n > 0 ? n : fallback;
    }
    $scope.retention = {
        min:     positiveInt(retentionConfig.min, 1),
        max:     positiveInt(retentionConfig.max, 720),
        default: positiveInt(retentionConfig['default'], 24)
    };

    // Discovery Data Retention Window (minutes): bounds and default from the central config, always
    // strictly below the ingestion window (account-ms clamps it the same way)
    var discoveryConfig = ConfigurationService.getFromCache(
        'frontend.organization_preferences.discovery_data_retention_minutes') || {};
    $scope.discovery = {
        min:     positiveInt(discoveryConfig.min, 30),
        max:     positiveInt(discoveryConfig.max, 1440),
        default: positiveInt(discoveryConfig['default'], 60)
    };

    /** The slider's maximum: the configured one, below the ingestion window chosen right now. */
    $scope.discoveryMax = function () {
        var hours = $scope.isRetentionValid() ? $scope.formData.retentionHours : $scope.retention.min;
        return Math.max($scope.discovery.min, Math.min($scope.discovery.max, hours * 60 - 1));
    };

    /** 45 → "45 min", 60 → "1 h", 90 → "1 h 30 min". */
    $scope.formatMinutes = function (minutes) {
        if (typeof minutes !== 'number' || isNaN(minutes)) return '';
        if (minutes < 60) return minutes + ' min';
        var h = Math.floor(minutes / 60), m = minutes % 60;
        return h + ' h' + (m ? ' ' + m + ' min' : '');
    };

    /** 24 → "24 h · 1 day", 36 → "36 h · 1.5 days", 6 → "6 h". */
    $scope.formatRetention = function (hours) {
        if (typeof hours !== 'number' || isNaN(hours)) return '';
        if (hours < 24) return hours + (hours === 1 ? ' hour' : ' hours');
        var days = Math.round(hours / 24 * 10) / 10;
        return hours + ' h · ' + days + (days === 1 ? ' day' : ' days');
    };

    $scope.formData = {
        organizationName:    '',
        description:         '',
        selectedAccountType: null,
        selectedCountry:     null,
        selectedState:       null,
        retentionHours:      $scope.retention.default,
        discoveryMinutes:    $scope.discovery.default
    };

    $scope.accountTypes = [];
    $scope.countries    = [];
    $scope.states       = [];

    // Snapshot fresco del backend — usado para hasChanges() y el diff en saveOrganization()
    var freshData = null;

    // ══════════════════════════════════════════════════════════════════
    //  CARGA INICIAL — account + refdata en paralelo
    // ══════════════════════════════════════════════════════════════════
    function loadInitialData() {
        $q.all({
            account:      UserProfileService.getAccount(accountId),
            accountTypes: ReferenceDataService.getReferenceData('USER_TYPE'),
            countries:    ReferenceDataService.getReferenceData('COUNTRY')
        })
        .then(function (results) {
            var account = results.account.data;
            freshData            = account;
            $scope.accountTypes  = results.accountTypes.data  || [];
            $scope.countries     = results.countries.data     || [];

            console.log('✅ Account data loaded:', account);
            console.log('✅ AccountTypes:', $scope.accountTypes.length,
                        '| Countries:', $scope.countries.length);

            // ── Inicializar formulario ──────────────────────────────
            $scope.formData.organizationName = account.organization || '';
            $scope.formData.description      = account.description || '';
            $scope.formData.retentionHours   = storedRetentionHours();
            $scope.formData.discoveryMinutes = storedDiscoveryMinutes();

            // ── Pre-seleccionar Account Type ────────────────────────
            if (account.accountTypeId) {
                $scope.formData.selectedAccountType = $scope.accountTypes.find(function (t) {
                    return t.refId === account.accountTypeId;
                }) || null;

                console.log($scope.formData.selectedAccountType
                    ? '✅ AccountType: ' + $scope.formData.selectedAccountType.refObjectLabel
                    : '⚠️ AccountType not found for id: ' + account.accountTypeId);
            }

            // ── Pre-seleccionar Country ─────────────────────────────
            if (account.countryId) {
                $scope.formData.selectedCountry = $scope.countries.find(function (c) {
                    return c.refId === account.countryId;
                }) || null;

                console.log($scope.formData.selectedCountry
                    ? '✅ Country: ' + $scope.formData.selectedCountry.refObjectLabel
                    : '⚠️ Country not found for id: ' + account.countryId);
            }

            // ── Cargar estados si hay country ───────────────────────
            if ($scope.formData.selectedCountry) {
                return loadStates($scope.formData.selectedCountry, account.stateId);
            }
        })
        .then(function () {
            $scope.loading = false;
        })
        .catch(function (error) {
            console.error('❌ loadInitialData error:', error);
            $scope.loading = false;
            dialogService.showErrorDialog('Load Error',
                'Failed to load organization data. Please close and try again.');
        });
    }

    // ══════════════════════════════════════════════════════════════════
    //  CARGAR ESTADOS
    //  preSelectStateId → null si el user acaba de cambiar el country
    // ══════════════════════════════════════════════════════════════════
    function loadStates(country, preSelectStateId) {
        var parentId = country.refObjectId || country.refId;

        return $http.get(CONFIG.BIZMETRY_BACKEND_URL + '/v1/api/bizmetry-shared/refdata/STATE', {
            params: {
                refParentObjectType: 'COUNTRY',
                refParentObjectId:   parentId
            }
        })
        .then(function (response) {
            $scope.states = response.data || [];
            console.log('✅ States loaded:', $scope.states.length,
                        '| parentId:', parentId);

            if ($scope.states.length === 0) {
                $scope.formData.selectedState = null;
                return;
            }

            var found = null;
            if (preSelectStateId) {
                found = $scope.states.find(function (s) {
                    return s.refId === preSelectStateId;
                }) || null;
            }
            $scope.formData.selectedState = found || $scope.states[0];
            console.log('✅ State: ' + $scope.formData.selectedState.refObjectLabel +
                        (found ? ' (pre-selected)' : ' (first fallback)'));
        });
    }

    // ══════════════════════════════════════════════════════════════════
    //  LOCATE MYSELF — geolocalización por IP
    // ══════════════════════════════════════════════════════════════════
    $scope.locateMyself = function () {
        $scope.locating = true;

        // El interceptor de $http agrega el token automáticamente —
        // no necesitamos pasarlo explícitamente
        geoLocationService.geolocateWithHeaders({})
            .then(function (geo) {
                $scope.locating = false;
                if (!geo || !geo.country_code) {
                    $mdToast.show($mdToast.simple()
                        .textContent('⚠️ Could not detect your location')
                        .position('top right').hideDelay(3000));
                    return;
                }
                prefillFromGeo(geo);
            })
            .catch(function () {
                $scope.locating = false;
                $mdToast.show($mdToast.simple()
                    .textContent('⚠️ Location detection failed')
                    .position('top right').hideDelay(3000));
            });
    };

    function prefillFromGeo(geo) {
        var countryName = (geo.country_name || '').toLowerCase();

        var matchedCountry = $scope.countries.find(function (c) {
            return (c.refObjectLabel || '').toLowerCase() === countryName;
        });

        if (!matchedCountry) {
            $mdToast.show($mdToast.simple()
                .textContent('⚠️ Country "' + geo.country_name + '" not found in list')
                .position('top right').hideDelay(3500));
            return;
        }

        $scope.formData.selectedCountry = matchedCountry;
        $scope.formData.selectedState   = null;
        $scope.states = [];

        var parentId = matchedCountry.refObjectId || matchedCountry.refId;

        $http.get(CONFIG.BIZMETRY_BACKEND_URL + '/v1/api/bizmetry-shared/refdata/STATE', {
            params: { refParentObjectType: 'COUNTRY', refParentObjectId: parentId }
        })
        .then(function (r) {
            $scope.states = r.data || [];

            var regionName = (geo.region      || '').toLowerCase();
            var regionCode = (geo.region_code || '').toLowerCase();

            var matchedState = $scope.states.find(function (s) {
                var label = (s.refObjectLabel || '').toLowerCase();
                return label === regionName || label === regionCode;
            });

            if (matchedState) {
                $scope.formData.selectedState = matchedState;
            }

            var msg = '📍 ' + matchedCountry.refObjectLabel +
                      (matchedState ? ', ' + matchedState.refObjectLabel : '');
            $mdToast.show($mdToast.simple()
                .textContent(msg)
                .position('top right').hideDelay(4000));
        })
        .catch(function () {});
    }

    // ══════════════════════════════════════════════════════════════════
    //  onCountryChange — acción del usuario
    // ══════════════════════════════════════════════════════════════════
    $scope.onCountryChange = function () {
        var country = $scope.formData.selectedCountry;
        $scope.formData.selectedState = null;
        $scope.states = [];

        if (!country) return;

        loadStates(country, null)
            .catch(function (error) {
                console.error('❌ Error loading states:', error);
                dialogService.showErrorDialog('Load Error',
                    'Failed to load states for the selected country.');
            });
    };

    // ══════════════════════════════════════════════════════════════════
    //  hasChanges — compara contra freshData
    // ══════════════════════════════════════════════════════════════════
    // The account answers every preference with its effective value; default if it predates them
    function storedRetentionHours() {
        var prefs = freshData && freshData.preferences;
        return prefs && prefs.ingestionHubRetentionHours ? prefs.ingestionHubRetentionHours
                                                         : $scope.retention.default;
    }

    function storedDiscoveryMinutes() {
        var prefs = freshData && freshData.preferences;
        return prefs && prefs.discoveryDataRetentionMinutes ? prefs.discoveryDataRetentionMinutes
                                                            : $scope.discovery.default;
    }

    $scope.isDiscoveryValid = function () {
        var minutes = $scope.formData.discoveryMinutes;
        return typeof minutes === 'number' && Math.floor(minutes) === minutes &&
               minutes >= $scope.discovery.min && minutes <= $scope.discoveryMax();
    };

    $scope.clampDiscovery = function () {
        var minutes = parseInt($scope.formData.discoveryMinutes, 10);
        if (isNaN(minutes)) minutes = storedDiscoveryMinutes();
        $scope.formData.discoveryMinutes = Math.min($scope.discoveryMax(), Math.max($scope.discovery.min, minutes));
    };

    // A shorter ingestion window drags the discovery one down with it
    $scope.$watch('formData.retentionHours', function () {
        if (typeof $scope.formData.discoveryMinutes === 'number' &&
            $scope.formData.discoveryMinutes > $scope.discoveryMax()) {
            $scope.formData.discoveryMinutes = $scope.discoveryMax();
        }
    });

    $scope.isRetentionValid = function () {
        var hours = $scope.formData.retentionHours;
        return typeof hours === 'number' && Math.floor(hours) === hours &&
               hours >= $scope.retention.min && hours <= $scope.retention.max;
    };

    $scope.isOrgNameValid = function () {
        var name = ($scope.formData.organizationName || '').trim();
        return name.length >= 3;
    };
    $scope.hasChanges = function () {
        if (!freshData) return false;

        if ($scope.formData.organizationName !== (freshData.organization || '')) return true;

        if ($scope.formData.description !== (freshData.description || '')) return true;

        if ($scope.formData.selectedAccountType &&
            $scope.formData.selectedAccountType.refId !== freshData.accountTypeId) return true;

        if ($scope.formData.selectedCountry &&
            $scope.formData.selectedCountry.refId !== freshData.countryId) return true;

        if ($scope.formData.selectedState &&
            $scope.formData.selectedState.refId !== freshData.stateId) return true;

        if ($scope.formData.retentionHours !== storedRetentionHours()) return true;

        if ($scope.formData.discoveryMinutes !== storedDiscoveryMinutes()) return true;

        return false;
    };

    // ══════════════════════════════════════════════════════════════════
    //  saveOrganization — solo envía campos que cambiaron
    // ══════════════════════════════════════════════════════════════════
    /** Why Save is disabled (its tooltip), or '' when it can save. */
    $scope.saveDisabledReason = function () {
        if ($scope.loading || $scope.saving) return 'Please wait…';
        var reasons = [];
        if (!$scope.isOrgNameValid()) reasons.push('Organization name needs at least 3 characters.');
        if (!$scope.isRetentionValid()) {
            reasons.push('Retention must be between ' + $scope.formatRetention($scope.retention.min) +
                         ' and ' + $scope.formatRetention($scope.retention.max) + '.');
        }
        if (!$scope.isDiscoveryValid()) {
            reasons.push('Discovery retention must be between ' + $scope.formatMinutes($scope.discovery.min) +
                         ' and ' + $scope.formatMinutes($scope.discoveryMax()) + '.');
        }
        if (reasons.length) return reasons.join('\n');
        return $scope.hasChanges() ? '' : 'No changes to save.';
    };

    /** The number input next to the slider: whole hours, inside the configured range. */
    $scope.clampRetention = function () {
        var hours = parseInt($scope.formData.retentionHours, 10);
        if (isNaN(hours)) hours = storedRetentionHours();
        $scope.formData.retentionHours = Math.min($scope.retention.max, Math.max($scope.retention.min, hours));
    };

    $scope.saveOrganization = function () {
        if ($scope.saveDisabledReason()) return;
        if (!$scope.formData.organizationName ||
            !$scope.formData.organizationName.trim()) {
            dialogService.showErrorDialog('Validation Error',
                'Organization name is required.');
            return;
        }

        $scope.saving = true;
        var payload = {};

        if ($scope.formData.organizationName !== (freshData.organization || '')) {
            payload.organizationName = $scope.formData.organizationName;
        }
        if ($scope.formData.description !== (freshData.description || '')) {
            payload.description = $scope.formData.description;
        }
        if ($scope.formData.selectedAccountType &&
            $scope.formData.selectedAccountType.refId !== freshData.accountTypeId) {
            payload.accountTypeId   = $scope.formData.selectedAccountType.refId;
            payload.accountTypeName = $scope.formData.selectedAccountType.refObjectLabel;
        }
        if ($scope.formData.selectedCountry &&
            $scope.formData.selectedCountry.refId !== freshData.countryId) {
            payload.countryId   = $scope.formData.selectedCountry.refId;
            payload.countryName = $scope.formData.selectedCountry.refObjectLabel;
        }
        if ($scope.formData.selectedState &&
            $scope.formData.selectedState.refId !== freshData.stateId) {
            payload.stateId   = $scope.formData.selectedState.refId;
            payload.stateName = $scope.formData.selectedState.refObjectLabel;
        }

        if ($scope.formData.retentionHours !== storedRetentionHours()) {
            if (!$scope.isRetentionValid()) {
                dialogService.showErrorDialog('Validation Error',
                    'The Ingestion Hub Retention Time Window must be between ' +
                    $scope.formatRetention($scope.retention.min) + ' and ' +
                    $scope.formatRetention($scope.retention.max) + '.');
                $scope.saving = false;
                return;
            }
            payload.preferences = { ingestionHubRetentionHours: $scope.formData.retentionHours };
        }
        if ($scope.formData.discoveryMinutes !== storedDiscoveryMinutes()) {
            payload.preferences = payload.preferences || {};
            payload.preferences.discoveryDataRetentionMinutes = $scope.formData.discoveryMinutes;
        }

        if (Object.keys(payload).length === 0) {
            dialogService.showInfoDialog('No Changes', 'No changes were made.');
            $scope.saving = false;
            return;
        }

        console.log('📤 PATCH payload:', payload);

        $http.patch(CONFIG.BIZMETRY_BACKEND_URL +
                    '/v1/api/bizmetry-account/account/' + accountId, payload)
            .then(function () {
                $scope.saving = false;

                // Construir updatedData para que el padre actualice su scope
                var updatedData = {
                    organizationName: $scope.formData.organizationName,
                    description:     $scope.formData.description,
                    accountTypeId:   $scope.formData.selectedAccountType
                                        ? $scope.formData.selectedAccountType.refId
                                        : freshData.accountTypeId,
                    accountTypeName: $scope.formData.selectedAccountType
                                        ? $scope.formData.selectedAccountType.refObjectLabel
                                        : freshData.accountTypeLabel,
                    countryId:       $scope.formData.selectedCountry
                                        ? $scope.formData.selectedCountry.refId
                                        : freshData.countryId,
                    countryName:     $scope.formData.selectedCountry
                                        ? $scope.formData.selectedCountry.refObjectLabel
                                        : freshData.countryLabel,
                    stateId:         $scope.formData.selectedState
                                        ? $scope.formData.selectedState.refId
                                        : freshData.stateId,
                    stateName:       $scope.formData.selectedState
                                        ? $scope.formData.selectedState.refObjectLabel
                                        : freshData.stateLabel,
                    preferences:     { ingestionHubRetentionHours:    $scope.formData.retentionHours,
                                       discoveryDataRetentionMinutes: $scope.formData.discoveryMinutes }
                };

                $mdDialog.hide(updatedData);
            })
            .catch(function (error) {
                console.error('❌ Error saving organization:', error);
                $scope.saving = false;
                var msg = (error.data && error.data.message)
                    ? error.data.message
                    : 'Failed to update organization information.';
                dialogService.showErrorDialog('Update Error', msg);
            });
    };

    // ══════════════════════════════════════════════════════════════════
    //  cancel / copyOrgId
    // ══════════════════════════════════════════════════════════════════
    $scope.cancel = function () {
        $mdDialog.cancel();
    };

    $scope.copyOrgId = function () {
        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(accountId)
                .then(function () {
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent('Organization ID copied to clipboard')
                            .position('top right')
                            .hideDelay(3000)
                    );
                })
                .catch(function () {
                    dialogService.showErrorDialog('Copy Failed',
                        'Failed to copy ID to clipboard.');
                });
        } else {
            var ta = document.createElement('textarea');
            ta.value = accountId;
            ta.style.cssText = 'position:fixed;left:-9999px';
            document.body.appendChild(ta);
            ta.select();
            try {
                document.execCommand('copy');
                dialogService.showSuccessDialog('Copied!',
                    'Organization ID copied to clipboard.');
            } catch (e) {
                dialogService.showErrorDialog('Copy Failed',
                    'Failed to copy ID to clipboard.');
            }
            document.body.removeChild(ta);
        }
    };

    // ── Arranque ──────────────────────────────────────────────────────
    loadInitialData();
});
